import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { InputComponent } from 'component/Input';

export const Position = (props) => (
  <AccordionBodyItem
    accordionSubId={`9.${props.id}`}
    titleUA="Посада/вид діяльності"
    titleEN="Position / activity"
    children={(
      <InputComponent
        value={props.formData.info.informators[props.index].position}
        handleInput={(value) => props.handleInformator('position', value)}
        blueLink
        limitChar
      />
    )}
  />
);
